import type {
  StringValidatorFn,
  StringValidatorInput,
  ValidateReturn,
} from '../formValidator.types';

export type ForbiddenOptions = { regexp: RegExp; errorMessage: string };

const defaultOptions: ForbiddenOptions = {
  regexp: /[<>="']/g,
  errorMessage: 'Forbidden characters: {{forbidden}}',
};

const validateInput = (
  input: StringValidatorInput = '',
  options: Partial<ForbiddenOptions> = defaultOptions,
): ValidateReturn => {
  const opts = { ...defaultOptions, ...options };
  const stringInput = input || '';
  const matchedChars = [...new Set(stringInput.match(opts.regexp))].join('');
  return opts.regexp.test(stringInput)
    ? opts.errorMessage.replace(/{{forbidden}}/, matchedChars)
    : undefined;
};

export const validateForbiddenChars = (
  input: StringValidatorInput,
): ValidateReturn => validateInput(input);

export const getValidateForbiddenCharsFn = (
  options: Partial<ForbiddenOptions>,
): StringValidatorFn => {
  return (input: StringValidatorInput) => validateInput(input, options);
};
